import * as React from 'react';
import '@ant-design/compatible/assets/index.css';
import { Layout, Row, Button, Modal, List } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { debounce } from '../../utils/PerformanceUtils';
import {
	getEntityById,
	getObjectValues,
	getPrimaryColor,
	getUnreadNotesIndexAndCount,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { workOrdersRestCrudThunksForBuyer } from '../../thunks/work_orders_thunks';
import {
	fetchAllUsersForBuyers,
	addBuyerSubscribersForBuyers,
	addSupplierSubscribersForBuyers,
	removeBuyerSubscriberForBuyers,
	removeSupplierSubscriberForBuyers,
} from '../../thunks/work_orders_subscribers_thunks';
import {
	NOTE_TYPE_LOG,
	NOTE_TYPE_SERVICE_CALL_CHECK_IN,
	NOTE_TYPE_SERVICE_CALL_CHECK_OUT,
} from '../../constants/NoteTypes';
import { ContactAvatar } from '../contact_avatar/ContactAvatar';
import BuyerNewWorkOrderNoteForm from '../buyer_new_work_order_note_form/BuyerNewWorkOrderNoteForm';
import { EmptyState } from '../empty_state/EmptyState';
import { fetchAllWorkOrderNotesForBuyer } from '../../thunks/messages_thunks';
import AvatarGroup from '../avatar_group/AvatarGroup';
import MessageBubble from '../MessageBubble';
import SelectUsers from '../select_users/SelectUsers';
import RemoveSubscriberButton from './RemoveSubscriberButton';
import { ROLE_TYPES } from '../../utils/DataConstants';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import MessageLog from '../MessageLog';
import ServiceCallLogEntry from '../ServiceCallLogEntry';
import { getCalculatedChatHeight } from '../../utils/ChatUtils';
import { formatUserContact } from '../../utils/DataFormatterUtils';
import { WebSocketContext } from '../../context/WebSocketContext';
import WebSocketTypingManager from './WebSocketTypingManager';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import {
	getContractorOrWorkOrderId,
	isNoteValid,
	UNREAD_NOTES_NOTIFICATION_KEY,
} from '../../utils/WorkOrderUtils';
import SeparatorWithText from '../common/SeperatorWithText';
import { WEB_SOCKET_ENTITY_TYPES } from '../../utils/WebSocketUtils';
import { NOTE_INPUT_ID } from '../../utils/DomUtils';

const { Content } = Layout;

require('./WorkOrdersDetailNotesPage.less');
class WorkOrderNotesDetailPage extends React.Component<any, any> {
	initialPagination: any;
	initialFilters: any;
	wsManager: any;
	targetRef: React.RefObject<HTMLDivElement>;

	static contextType = WebSocketContext;

	constructor(props) {
		super(props);

		this.state = {
			fetching: true,
			subscriberModalVisible: false,
			addSubscriberModalVisible: false,
			search: '',
			selectedUsers: [],
			selectValue: [],
			addingSubscribers: false,
			typingDetails: [],
			messages: [],
			refreshCount: 0,
		};

		this.targetRef = React.createRef();

		this.wsManager = new WebSocketTypingManager({
			component: this,
			socketProvider: () => this.context,
			getEntityIdsFromProps: (comProps) => [
				getContractorOrWorkOrderId(nullSafeGet('workOrder', comProps)),
			],
			getCurrentEntityIdFromProps: (comProps) =>
				getContractorOrWorkOrderId(nullSafeGet('workOrder', comProps)),
			entityIdName: 'workOrderId',
			entityType: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER_NOTES,
			newNoteEntityType: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER,
		});
	}

	setTargetHeight = () => {
		this.setState({ calculatedHeight: getCalculatedChatHeight('buyer-workorder-detail-header') });
	};

	refreshMessages = () => {
		const { fetchMessages, match, updateWorkOrderPartiallyInRedux } = this.props;

		const workOrderId = match.params.id;
		updateWorkOrderPartiallyInRedux({
			id: parseInt(workOrderId),
			[UNREAD_NOTES_NOTIFICATION_KEY]: false,
		});
		return new Promise((resolve, reject) => {
			fetchMessages(workOrderId)
				.then((res) => {
					resolve(res);
					this.setState((prevState) => ({
						refreshCount: (prevState.refreshCount || 0) + 1,
						newNoteCount: 0,
						typingDetails: [],
					}));
				})
				.catch(reject);
		});
	};

	scrollToTop = () => {
		const element = document.getElementById('chatBox');
		if (element) {
			element.scrollTop = element.scrollHeight;
		}
	};

	componentDidMount() {
		this.refreshMessages().then(() => {
			this.setState({ fetching: false }, () => {
				this.scrollToTop();
			});
		});
		this.setTargetHeight();
		window.addEventListener('resize', this.setTargetHeight);

		this.wsManager.onMount();
	}

	updateWithLatestNotes = (prevProps) => {
		const { match } = this.props;
		const workOrderId = match.params.id;
		const prevNotes = nullSafeGetOrElse(`${workOrderId}.messages`, prevProps.messages, []);
		const newNotes = nullSafeGetOrElse(`${workOrderId}.messages`, this.props.messages, []);

		if (newNotes !== prevNotes && newNotes.length > 0) {
			this.setState({ messages: newNotes }, () => {
				this.scrollToTop();
			});
		}
	};

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.setTargetHeight();
		}
		this.updateWithLatestNotes(prevProps);
		this.wsManager.onUpdate();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.setTargetHeight);

		this.wsManager.onUnmount();
	}

	handleSubscriberModalClose = () => {
		this.setState({ subscriberModalVisible: false });
	};

	handleSubscriberModalOpen = () => {
		this.setState({ subscriberModalVisible: true });
	};
	handleAddSubscriberModalClose = () => {
		this.setState({ addSubscriberModalVisible: false });
	};
	handleAddSubscriberModalOpen = () => {
		this.setState({ addSubscriberModalVisible: true });
		this.setState({ search: '', selectedUsers: [] });
	};

	handleSubscriberRemoved = (item) => () => {
		const { removeBuyerSubscriber, removeSupplierSubscriber, match, workOrder } = this.props;
		if (item.contactType === ROLE_TYPES.BUYER) {
			let obj = { id: parseInt(match.params.id), removeBuyerSubscriberEmails: [item.email] };
			removeBuyerSubscriber(obj, workOrder);
		} else {
			let obj = { id: parseInt(match.params.id), removeSupplierSubscriberEmails: [item.email] };
			removeSupplierSubscriber(obj, workOrder);
		}
	};
	handleAddSubscribers = () => {
		const { selectedUsers } = this.state;
		const { match, workOrder, addBuyerSubscribers, addSupplierSubscribers } = this.props;
		this.setState({ addingSubscribers: true });
		let objBuyer = {
			id: parseInt(match.params.id),
			addBuyerSubscriberEmails: selectedUsers
				.filter((user) => user.contactType === 'buyer')
				.map((user) => user.email),
		};
		let objSupplier = {
			id: parseInt(match.params.id),
			addSupplierSubscriberEmails: selectedUsers
				.filter((user) => user.contactType === 'supplier')
				.map((user) => user.email),
		};
		const subscribersAddition = [
			...(objBuyer.addBuyerSubscriberEmails.length > 0
				? [addBuyerSubscribers(objBuyer, workOrder)]
				: []),
			...(objSupplier.addSupplierSubscriberEmails.length > 0
				? [addSupplierSubscribers(objSupplier, workOrder)]
				: []),
		];
		Promise.all(subscribersAddition).then(() => {
			this.setState({
				selectValue: [],
				addingSubscribers: false,
			});
			this.handleAddSubscriberModalClose();
		});
	};
	handleOnChange = (val) => {
		let updatedVal = Array.isArray(val) ? val.map((v) => JSON.parse(v)) : JSON.parse(val);
		if (!('value' in this.props)) {
			this.setState({ value: updatedVal });
		}

		this.setState({
			selectValue: updatedVal.map((val) => JSON.stringify(val)),
			selectedUsers: updatedVal,
		});
		this.triggerChange(updatedVal);
	};
	triggerChange = (changedValue) => {
		// Should provide an event to pass value to Form.
		const onChange = this.props.onChange;
		if (onChange) {
			onChange(changedValue);
		}
	};

	debouncedCallback = debounce(
		(searchText) => {
			const { fetchUsers, workOrder } = this.props;
			fetchUsers(searchText && searchText.trim(), workOrder['id']);
		},
		400,
		false
	);
	handleAddSubscriberSearchDebounced = (value = '') => {
		const searchText = value && value.trim();
		this.setState({ search: searchText });
		this.debouncedCallback(searchText);
	};

	render() {
		const { workOrder, currentUser, match, searched_subscribers } = this.props;
		const { fetching } = this.state;
		const workOrderId = match.params.id;
		const notes = this.state.messages;
		const actualNotes = notes.filter(isNoteValid);

		let subscribers = (workOrder.buyerSubscribers || []).concat(
			workOrder.supplierSubscribers || []
		);
		if (
			workOrder.supplierSubscribers &&
			workOrder.supplierSubscribers.length === 0 &&
			nullSafeGet('supplierFacility.id', workOrder)
		) {
			subscribers.push({
				nameGiven: nullSafeGet('supplierFacility.displayName', workOrder),
				nameFamily: '',
				email: nullSafeGet('supplierSubscriberEmails.0', workOrder),
			});
		}

		const filteredUsers = getObjectValues(searched_subscribers.records).map((el) =>
			formatUserContact(el)
		);

		const { firstUnreadMessageIndex, unreadMessageLength } = getUnreadNotesIndexAndCount(
			actualNotes,
			currentUser
		);

		return fetching ? (
			<PageLoadingPlaceholder />
		) : (
			<Content
				ref={this.targetRef}
				style={{
					height: `${this.state.calculatedHeight}px`,
					maxHeight: `${this.state.calculatedHeight}px`,
				}}
				className="workOrdersDetailNotesPage"
			>
				<div style={{ textAlign: 'right', padding: '0', height: '0px' }}>
					<Modal
						width={600}
						title={
							<div>
								<span style={{}}>Work Order {workOrderId}</span>
								<OWButtonWithSupplierManagedLock
									style={{ float: 'right', marginRight: '32px', marginTop: '-4px' }}
									onClick={this.handleAddSubscriberModalOpen}
									type={'primary'}
								>
									Add People
								</OWButtonWithSupplierManagedLock>
							</div>
						}
						footer={null}
						closable={true}
						onCancel={this.handleSubscriberModalClose}
						visible={this.state.subscriberModalVisible}
					>
						<List
							itemLayout="horizontal"
							dataSource={subscribers}
							renderItem={(item) => (
								<List.Item>
									<List.Item.Meta
										avatar={
											<ContactAvatar
												hidePopover={true}
												placement="bottomRight"
												userType="buyer"
												contact={item}
											/>
										}
										// @ts-ignore
										title={`${item.nameGiven} ${item.nameFamily}`}
										// @ts-ignore
										description={item.email}
									/>
									<RemoveSubscriberButton
										subscriber={item}
										onRemove={this.handleSubscriberRemoved}
										workOrder={workOrder}
									/>
								</List.Item>
							)}
						/>
					</Modal>
					<Modal
						width={600}
						title={
							<div>
								<span>Add Someone to Work Order {workOrderId}</span>
							</div>
						}
						footer={
							<div style={{ display: 'block', width: '100%' }}>
								<Button
									loading={this.state.addingSubscribers}
									onClick={this.handleAddSubscribers}
									type={'primary'}
								>
									Add Subscribers
								</Button>
							</div>
						}
						closable={true}
						onCancel={this.handleAddSubscriberModalClose}
						visible={this.state.addSubscriberModalVisible}
					>
						<Row key={0}>
							<SelectUsers
								mode="multiple"
								style={{ width: '100%' }}
								placeholder="Begin to type a name or email to start searching"
								onSearch={this.handleAddSubscriberSearchDebounced}
								onFocus={() => this.handleAddSubscriberSearchDebounced()}
								onChange={this.handleOnChange}
								search={this.state.search}
								selectValue={this.state.selectValue}
								filteredUsers={filteredUsers}
								disabledUsers={subscribers}
							/>
						</Row>
					</Modal>
				</div>
				<div className="flex flex-row justify-end pr-4">
					<AvatarGroup
						avatars={subscribers}
						onClick={this.handleSubscriberModalOpen}
						onAddClick={this.handleAddSubscriberModalOpen}
					/>
				</div>
				<div
					id="chatBox"
					style={{
						flexGrow: 1,
						overflowY: 'auto',
					}}
					className="no-scrollbar"
				>
					{actualNotes.length > 0 ? (
						<div className="chatList">
							{actualNotes.map((n, idx) => (
								<React.Fragment key={`note-${idx}`}>
									{firstUnreadMessageIndex === idx ? (
										<SeparatorWithText
											className="mt-2 px-8"
											text={`${unreadMessageLength} ${
												this.state.refreshCount > 1 ? 'new' : 'unread'
											} message${unreadMessageLength > 1 ? 's' : ''}`}
											textColor={getPrimaryColor(ROLE_TYPES.BUYER)}
											bgColor={getPrimaryColor(ROLE_TYPES.BUYER)}
										/>
									) : null}
									{n.type === NOTE_TYPE_LOG ? (
										<MessageLog log={n} />
									) : n.type === NOTE_TYPE_SERVICE_CALL_CHECK_IN ||
									  n.type === NOTE_TYPE_SERVICE_CALL_CHECK_OUT ? (
										<ServiceCallLogEntry entry={n} type={n.type} />
									) : (
										<MessageBubble
											currentUser={currentUser}
											n={n}
											idx={idx}
											subscribers={subscribers}
											userType="buyer"
											key={idx}
											workOrder={workOrder}
										/>
									)}
								</React.Fragment>
							))}
						</div>
					) : (
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/letter owl.svg"
									alt="Add a note to this work order using the box below."
								/>
							}
							headline={'No notes have been added yet'}
							body={
								<div style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 440, marginBottom: 16 }}>
										Add a note to this work order using the box below.
									</div>
								</div>
							}
						/>
					)}
				</div>
				<div id={NOTE_INPUT_ID}>
					<BuyerNewWorkOrderNoteForm
						workOrder={workOrder}
						fetchMessages={this.props.fetchMessages}
						onTyping={this.wsManager.handleTyping}
						onSendNote={this.wsManager.onSendNote}
						typingDetails={this.state.typingDetails}
						newNoteCount={this.state.newNoteCount}
						onRefresh={this.refreshMessages}
					/>
				</div>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	messages: state.messages,
	currentUser: state.session.currentUser,
	searched_subscribers: state.searched_subscribers,
	match: ownProps.match,
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForBuyer.readOne(id)),
	fetchMessages: (workOrderId) => dispatch(fetchAllWorkOrderNotesForBuyer(workOrderId)),
	fetchUsers: (search, woId, filters) => dispatch(fetchAllUsersForBuyers(search, woId, filters)()),
	addBuyerSubscribers: (obj, workOrder) => dispatch(addBuyerSubscribersForBuyers(obj)(workOrder)),
	addSupplierSubscribers: (obj, workOrder) =>
		dispatch(addSupplierSubscribersForBuyers(obj)(workOrder)),
	removeBuyerSubscriber: (obj, workOrder) =>
		dispatch(removeBuyerSubscriberForBuyers(obj)(workOrder)),
	removeSupplierSubscriber: (obj, workOrder) =>
		dispatch(removeSupplierSubscriberForBuyers(obj)(workOrder)),
	updateWorkOrderPartiallyInRedux: (workOrder) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updatePartialSuccess(workOrder)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkOrderNotesDetailPage));
